import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer-section py-5 mt-5">
      <div className="container relative">
        <div className="sofa-img">
          <img src="/images/sofa.png" alt="sofa" className="" />
        </div>

        <div className="row g-5 mb-5">

          {/* Logo + About */}
          <div className="col-lg-4">
            <div className="mb-4 footer-logo-wrap">
              <a className="navbar-brand" href="/">
  <img src="/images/logo2.png" alt="logo" style={{ height: "40px" }} />
</a>
            </div>

            <p className="mb-4">
              Founded in 2021 by professional experts in the Furniture & Interiors industry, deeply passionate about modern design, aesthetics, ergonomics and functionality. The brand concept is based on the principles of timeless designs, natural and sustainable materials, textures and craftsmanship that bring warmth, durability and care with sophisticated functionality into every home, institution and commercial facility.
            </p>

            
          </div>

          {/* Links */}
          <div className="col-lg-8">
            <div className="row links-wrap">

              <div className="col-6 col-sm-6 col-md-4">
  <ul className="list-unstyled">
    <li><Link to="/">Home</Link></li>
    <li><Link to="/services">Services</Link></li>
    <li><a href="/terms">Terms & Conditions</a></li>
    <li><Link to="/contact">Contact us</Link></li>
  </ul>
</div>

              <div className="col-6 col-sm-6 col-md-4">
                <address>
                  FACTORY / OFFICEPlot A-163,<br /> Sector-80,
Noida, G.B. Nagar,<br />
U.P - 201305, INDIA
                </address>
                <p>
                  Email: contact@paab.in
                </p>
              </div>

              <div className="col-12 col-sm-12 col-md-4">
               <ul className="list-unstyled custom-social">
              <li><a href="/facebook"><span className="fa fa-brands fa-facebook-f"></span></a></li>
              <li><a href="/twitter"><span className="fa fa-brands fa-twitter"></span></a></li>
              <li><a href="/instagram"><span className="fa fa-brands fa-instagram"></span></a></li>
              <li><a href="/linkedin"><span className="fa fa-brands fa-linkedin"></span></a></li>
            </ul>

            <div>
                <img src="/images/sedex-services.png" alt="" style={{ height: "40px" }} />
                <img src="/images/bifma.png" alt="" style={{ height: "40px" }} />
                <img src="/images/riksh.jpg" alt="" style={{ height: "40px" }} />
                <img src="/images/9001.webp" alt="" style={{ height: "40px" }} />
                <img src="/images/14001.png" alt="" style={{ height: "40px" }} />
                <img src="/images/45001.jpg" alt="" style={{ height: "40px" }} />
              </div>
              </div>

              

              

            </div>
          </div>

        </div>

        {/* Bottom */}
        <div className="border-top copyright">
          <div className="row pt-4">

            <div className="col-lg-6">
              <p className="mb-2 text-center text-lg-start">
                © {new Date().getFullYear()} All Rights Reserved.
              </p>
            </div>

            <div className="col-lg-6 text-center text-lg-end">
              <ul className="list-unstyled d-inline-flex ms-auto">
                <li className="me-4"><a href="/terms">Terms & Conditions</a></li>
                <li><a href="/privacy">Privacy Policy</a></li>
              </ul>
            </div>

          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;